import withStyles from "@material-ui/core/styles/withStyles";
import React from 'react';
import PropTypes from 'prop-types';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { FormContext } from './Form';


export const FormStepContext = React.createContext(null);

const styles = theme => ({
  paperPadding: {
    padding: 15,
  },
});

@withStyles(styles)
@observer
class FormStep extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    optional: PropTypes.string,
  };
  static defaultProps = {
    label: '',
    optional: '',
  };

  static contextType = FormContext;

  @observable index = 0;
  @observable fields = [];

  componentDidMount() {
    if (this.context === null) {
      throw Error('No form context found in FormStep ancestors.');
    }
    const { label, optional } = this.props;
    this.index = this.context.stepsData.length;
    this.context.stepsData.push({
      label,
      optional,
      fields: this.fields
    });
  }

  render() {
    return (
      <FormStepContext.Provider value={{
        instance: this.context.instance,
        fields: this.fields
      }}>
        <div hidden={this.context.activeStep !== this.index}>
          {this.props.children}
        </div>
      </FormStepContext.Provider>
    );
  }
}


export default FormStep;
